import {ParamMap} from "@angular/router";
import {NavController} from "@ionic/angular";
import {Injectable} from "@angular/core";
import {json} from "@angular-devkit/core";

@Injectable({ providedIn: 'root' })
export class RouteUtils {

    constructor(private navController: NavController) {}

    public getValue(name: string, paramMap: ParamMap, defaultValue?: string): string {
        if (!name  || !paramMap) {
            throw new Error('name and paramMap arguments are mandatory')
        }
        const value = paramMap.get(name);
        return value ? value : defaultValue;
    }

    public getValueOrRedirectTo500(name: string, paramMap: ParamMap): any {
        const value = this.getValue(name, paramMap);
        if (!value) {
            // console.logByType'Redirect to 500 cause ' + name + ' parameter is missing');
            this.navController.navigateRoot('500');
        }
        return value;
    }

    public getValueOrRedirectTo404(name: string, paramMap: ParamMap): any {
        const value = this.getValue(name, paramMap);
        if (!value) {
            console.log('Redirect to 404 cause ' + name + ' parameter is missing');
            this.navController.navigateRoot('404');
        }
        return value;
    }

    public getValueAsNumber(name: string, paramMap: ParamMap): number {
        const value = this.getValue(name, paramMap);
        if (value) {
            return +value;
        }
    }

    public getValueAsNumberOrRedirectTo500(name: string, paramMap: ParamMap): number {
        const value = this.getValueAsNumber(name, paramMap);
        if (!value) {
            // console.logByType'Redirect to 500 cause ' + name + ' parameter is missing');
            this.navController.navigateRoot('500');
        }
        return value;
    }

    public getValueAsNumberOrRedirectTo404(name: string, paramMap: ParamMap): number {
        const value = this.getValueAsNumber(name, paramMap);
        if (!value) {
            // console.logByType'Redirect to 404 cause ' + name + ' parameter is missing');
            this.navController.navigateRoot('400');
        }
        return value;
    }

    public getRedirectUrl(paramMap: ParamMap) {
        return this.getValue('returnUrl', paramMap);
    }

    public getInitialFormState(paramMap: ParamMap) {
        const initialFormState =  this.getValue('initialFormState', paramMap);
        if (initialFormState) {
            const decodedString = atob(initialFormState); // Décoder la chaîne encodée
            const jsonValue = JSON.parse(decodedString);
            return jsonValue;
        }
        return undefined;
    }

    public getInitialFormStateFormData(data: any) {
        const initialFormState =  data?.initialFormData;
        if (initialFormState) {
            const decodedString = atob(initialFormState); // Décoder la chaîne encodée
            const jsonValue = JSON.parse(decodedString);
            return jsonValue;
        }
        return undefined;
    }

}
